var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.638,
    height: 26.742,
    viewBox: "0 0 44.638 26.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1417"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#535151}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "handle",
    transform: "translate(-741 -797.258)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1417-2",
    "data-name": "Rectangle 1417",
    className: "cls-1",
    d: "M0 0h42v16a9 9 0 0 1-9 9H1a1 1 0 0 1-1-1V0z",
    transform: "translate(741 799)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(741 797.26)",
    style: {
      filter: "url(#Rectangle_1417)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1417-3",
    "data-name": "Rectangle 1417",
    d: "M0 0h42v16a9 9 0 0 1-9 9H1a1 1 0 0 1-1-1V0z",
    transform: "translate(0 1.74)",
    style: {
      fill: "#fff"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    className: "cls-1",
    d: "M9395.338 2083.067h-42.013l2.041-1.742h42.6z",
    transform: "translate(-8612.325 -1284.067)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkHandle);
export default __webpack_public_path__ + "static/media/darkHandle.059347e4fbf8331750b990ea5b090982.svg";
export { ForwardRef as ReactComponent };